<div class="explore">

  <!--begin::Internal Posts/Events List(Carousel)
  <sng-posts_events-list-carousel *ngIf="configAccess[0]" [type]="'all'" [access]="'internal'">
  </sng-posts_events-list-carousel>
  end::Internal Posts/Events List(Carousel)-->

  <hr>
  <br>

  <!--begin::Partners List(Carousel)-->
  <sng-partners-list-carousel>
  </sng-partners-list-carousel>
  <!--end::Partners List(Carousel)-->

  <hr>
  <br>

  <!--begin::General Posts/Events List(Carousel)-->
  <sng-posts_events-list-carousel *ngIf="configAccess[0]" [type]="'all'" [access]="'general'">
  </sng-posts_events-list-carousel>
  <!--end::General Posts/Events List(Carousel)-->

</div>
